import React from "react";

import * as SC from "./PrintAdpreview.styled";

import { channelsByShortName } from "../../../../data/app__channels.js";
import PrintPostPreview from "./print-post-preview/PrintPostPreview";
import { useCampaignContext } from "../../../../context/Campaign.context.jsx";
import { useTranslation } from "react-i18next";

const PrintAdpreview = ({ posts, channelsData, contentRef }) => {
  const { t } = useTranslation();
  const { selectedChannels } = useCampaignContext();

  const renderCreative = ({ creativeIndex, post, postIndex, channel, channelIndex }) => {
    const postChannelData =
      channelsData[channel].find((channelData) => channelData.postNumber === post.postNumber) ||
      channelsData[channel]; // If there is no channelData for this post, use the channelData for the whole channel this is for old campaigns

    const key = `${channelIndex}_${post.postNumber}_${creativeIndex}`;
    const channelFullName = channelsByShortName[channel].channel_full_name;

    const isLastPost =
      channelIndex === selectedChannels.length - 1 && postIndex === posts[channel].length - 1;

    const hasMobileView = ["facebook", "google-search"].includes(channel);

    return (
      <div key={key}>
        <div key={`${key}_web`}>
          <SC.PostToPrint>
            <SC.PostName>
              {channelFullName} {t("Web View")} #{post.postNumber},{creativeIndex + 1}
            </SC.PostName>
            <PrintPostPreview
              selectedPreviewChannel={channel}
              postData={post}
              channelData={postChannelData}
              selectedPostNumber={post.postNumber}
              channelPosts={posts[channel]}
              selectedCreativeIndexToEdit={creativeIndex}
              mobile={false}
            />
          </SC.PostToPrint>
          {isLastPost && !hasMobileView && <SC.PageBreak />}
        </div>

        {hasMobileView && (
          <div key={`${key}_mobile`}>
            <SC.PostToPrint>
              <SC.PostName>
                {channelFullName} {t("Mobile View")} #{postIndex + 1},{creativeIndex + 1}
              </SC.PostName>
              <PrintPostPreview
                selectedPreviewChannel={channel}
                postData={post}
                channelData={postChannelData}
                selectedPostNumber={post.postNumber}
                channelPosts={posts[channel]}
                selectedCreativeIndexToEdit={creativeIndex}
                mobile={true}
                editable={false}
                clientView={true}
              />
            </SC.PostToPrint>
          </div>
        )}

        {!isLastPost && <SC.PageBreak />}
      </div>
    );
  };

  if (!posts) return <SC.PostsToPrint />;

  return (
    <SC.PostsToPrint ref={contentRef}>
      {selectedChannels?.map((channel, channelIndex) =>
        posts[channel]?.map((post, postIndex) => {
          // Google search and Spotify do not support multiple creatives
          if (post.creatives?.length > 1 && (channel == "google-search" || channel == "spotify")) {
            post.creatives = post.creatives.slice(0, 1);
          }

          return post.creatives.map((creative, creativeIndex) =>
            renderCreative({ creative, creativeIndex, post, postIndex, channel, channelIndex })
          );
        })
      )}
    </SC.PostsToPrint>
  );
};

export default PrintAdpreview;
